<template>
  <div>
    <title>销售员账号管理</title>
    <section class="mainPart">
      <!--S 公用头部切换-->
      <CompanyTab></CompanyTab>
      <!--E 公用头部切换-->
      <el-form :model="salesmanSearchForm" inline class="pt60">
          <el-form-item label="关键词">
            <el-input v-model="salesmanSearchForm.flowname" placeholder="请输入内容" clearable></el-input>
          </el-form-item>
          <el-form-item label="手机号码">
            <el-input v-model="salesmanSearchForm.mobile" placeholder="请输入手机号码" clearable></el-input>
          </el-form-item>
          <el-form-item label="支局（单位）名称">
            <el-input v-model="salesmanSearchForm.idnumber" placeholder="请输入支局（单位）名称" clearable></el-input>
          </el-form-item>
          <el-form-item label="状态" class="formTimeSlot">
            <el-select v-model="salesmanSearchForm.status" placeholder="请选择" clearable>
              <el-option label="禁用" :value="0"></el-option>
              <el-option label="启用" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="审核状态">
            <el-select v-model="salesmanSearchForm.examinestatus" placeholder="请选择" clearable>
              <el-option label="待审核" :value="0"></el-option>
              <el-option label="审核通过" :value="1"></el-option>
              <el-option label="审核不通过" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="querySalesSearch">查询</el-button>
          </el-form-item>
        </el-form>
      <el-table :data="salesManData" class="comTable" border ref="salesTable" :height="tableEleHeight" v-loading="isSalesmanLoad">
        <el-table-column label="序号" type="index" width="60"></el-table-column>
        <el-table-column label="销售员" min-width="280">
          <template slot-scope="scope">
            <dl class="pdr70 linkNum">
              <dt class="iconuser textFl" :title="scope.row.flowname">{{scope.row.flowname}} 
                <el-tag :type="scope.row.examinestatus==0?'warning':(scope.row.examinestatus==2?'danger':'primary')" :title="scope.row.examinestatus | examineStatusFilter">{{scope.row.examinestatus | examineStatusFilter}}</el-tag>
              </dt>
              <dd class="flexUI">
                <span v-if="scope.row.mobile" class="iconiPhone" :title="'手机号码：'+scope.row.mobile">{{scope.row.mobile}}</span>
                <span v-if="scope.row.idnumber" class="icongh" :title="'支局（单位）名称：'+scope.row.idnumber">{{scope.row.idnumber}}</span>
              </dd>
            </dl>
          </template>
        </el-table-column>
        <el-table-column label="单位地址" min-width="280">
          <template slot-scope="scope">
            <div v-if="scope.row.province || scope.row.city || scope.row.city || scope.row.addrdet">
              <p>{{scope.row.province}}&nbsp;{{scope.row.city}}&nbsp;{{scope.row.district}}</p>
              <small v-if="scope.row.addrdet" class="textFl pdr70" :title="scope.row.addrdet">{{scope.row.addrdet}}</small>
            </div>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="微信头像/昵称" min-width="200">
          <template slot-scope="scope">
            <div class="flexUpDownCenter wechatAvatar" v-if="scope.row.hpurl || scope.row.nickname">
              <p><img class="imgAlign" :src="scope.row.hpurl ? scope.row.hpurl : 'https://presale.jhtsoft.com/picms/c47519dc61feb.png'"></p>
              <span>{{scope.row.nickname}}</span>
            </div>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" sortable prop="elerequired" min-width="200">
          <template slot-scope="scope">
            <el-switch :value="scope.row.status?true:false" @change="handleSwitch(scope.row,1)" class="isSwitch" :width="45" :active-text="scope.row.status?'启':'禁'"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="120">
          <template slot-scope="scope">
            <p class="handle">
              <span @click="salesmanOperate(0,scope.row.flowcode)">详情</span>
              <span @click="salesmanOperate(1,scope.row.flowcode)">编辑</span>
            </p>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="noData"><span>暂无数据</span></div>
        </template>
      </el-table>
      <!-- E 分类列表 -->
      <!-- S 分页 -->
      <Page :pageTotal="pagebean.totalnum" :currentPage="currentPage" @nowPageParam="updatePage"></Page>
      <!-- E 分页 -->
        
    </section>


    <!-- S 增改查销售员弹窗 -->
    <el-dialog :visible.sync="salesmanOperShow" class="comDlog examineDlg" :title="salesmanOperType == 1?'编辑':'详情'" append-to-body :close-on-click-modal="false">
      <!--S 销售员详情-->
      <ul class="basicWrap" v-if="salesmanOperType==0">
        <li>
          <em>审核状态：</em>
          <b>
            <el-tag :type="applicantInfo.examinestatus==0?'warning':(applicantInfo.examinestatus==2?'danger':'primary')" :title="applicantInfo.examinestatus | examineStatusFilter">{{applicantInfo.examinestatus | examineStatusFilter}}</el-tag><template v-show="applicantInfo.examinestatus==2">{{applicantInfo.memo}}</template>
          </b>
        </li>
        <li>
          <em>申请人：</em>
          <b>
            <el-tag v-if="applicantInfo.status==0" type="danger" plain>已禁用</el-tag>
            {{applicantInfo.flowname?applicantInfo.flowname:'--'}}
          </b>
        </li>
        <li>
          <em>手机号码：</em>
          <b>{{applicantInfo.mobile?applicantInfo.mobile:'--'}}</b>
        </li>
        <li>
          <em>支局（单位）名称：</em>
          <b>{{applicantInfo.idnumber?applicantInfo.idnumber:'--'}}</b>
        </li>
        <li class="rulrMemo">
          <em>单位地址：</em>
          <b>{{applicantInfo.province}} {{applicantInfo.city}} {{applicantInfo.district}} {{applicantInfo.addrdet}}</b>
        </li>
        <li>
          <em>所属总代理：</em>
          <b>{{applicantInfo.pflowname?applicantInfo.pflowname:'--'}}</b>
        </li>
        <li>
          <em>微信：</em>
          <b class="wxWrap flexUI">
            <span class="wxLogo"><img class="imgCenter" :src="applicantInfo.hpurl?applicantInfo.hpurl:'https://presale.jhtsoft.com/picms/c47519dc61feb.png'"></span>
            <p>{{applicantInfo.nickname}}</p>
          </b>
        </li>
      </ul>
      <!--E 销售员详情-->
      <el-form v-else :model="salesmanOperForm" ref="salesmanOperForm" label-width="180px" :rules="salesmanRules" class="comForm">
        <el-form-item label="审核状态" class="noformitem">
          <el-tag :type="applicantInfo.examinestatus==0?'warning':(applicantInfo.examinestatus==2?'danger':'primary')" :title="applicantInfo.examinestatus | examineStatusFilter">{{applicantInfo.examinestatus | examineStatusFilter}}</el-tag>{{applicantInfo.memo}}
        </el-form-item>
        <el-form-item label="销售员姓名" prop="flowname">
          <el-input v-model.trim="salesmanOperForm.flowname" clearable placeholder="请输入销售员姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="mobile">
          <el-input v-model.trim="salesmanOperForm.mobile" maxlength="11" placeholder="请输入手机号码" clearable></el-input>
        </el-form-item>
        <el-form-item label="支局（单位）名称" prop="idnumber">
          <el-input v-model.trim="salesmanOperForm.idnumber" maxlength="16" clearable placeholder="请输入支局（单位）名称"></el-input>
        </el-form-item>
        <el-form-item label="单位地址" prop="pcdinfo">
          <ProvincesOrCity
              v-model="salesmanOperForm.pcdinfo"
              :valueType="'nv'"
              :level="2"
              :initCode="'0'"
              :placeholder="'请选择省市区'">
            </ProvincesOrCity>
            <!-- <span class="disabledSpan">{{applicantInfo.province}}&nbsp;&nbsp;/&nbsp;&nbsp;{{applicantInfo.city}}&nbsp;&nbsp;/</span>
            <el-select v-model="salesmanOperForm.districtcode" clearable placeholder="请选择或输入" class="threeSel" @change="DSChange">
              <el-option
                v-for="item in districtList"
                :key="item.Code"
                :label="item.FullName"
                :value="item.Code">
              </el-option>
            </el-select> -->
        </el-form-item>
        <el-form-item prop="addrdet">
          <el-input type="textarea" v-model.trim="salesmanOperForm.addrdet" placeholder="输入详细地址，如门牌号，不少于5个字" maxlength="50" minlength="5" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="所属总代理" prop="pflowcode">
          <el-input v-model="applicantInfo.pflowname" disabled></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-switch v-model="salesmanOperForm.status" :width="45" class="isSwitch" :active-text="salesmanOperForm.status?'启':'禁'"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" v-if="salesmanOperType==1">
        <el-button type="primary" @click="saveSalesmanInfo(1)">确定</el-button>
        <el-button @click="saveSalesmanInfo(0)">取消</el-button>
      </div>
      <div slot="footer" class="dialog-footer" v-else>
        <el-button type="primary" @click="saveSalesmanInfo(0)">关闭</el-button>
      </div>
    </el-dialog>
    <!-- E 增改查销售员弹窗 -->

  </div>
</template>
<script>
import api from '@/apis/api.js';
import { Message, MessageBox } from "element-ui";
export default {
  name: 'SalesmanManage',
  data () {
    let that=this;
    return {
      qydm:'',//获取企业代码
      isSalesmanLoad:false,//加载中
      salesmanSearchForm: {
        flowname: "", //关键词
        mobile:'',
        idnumber:'',
        status:1,
        examinestatus:'',
      },//销售人员检索
      salesManData:[],//销售员列表
      pageSize: 30, // 销售员每页展示的条数
      currentPage: 1, // 当前销售员请求的页数
      pagebean:{
        totalnum: 0,
      }, // 销售员分页信息

      salesmanOperType:0,//销售员操作类型,0：详情，1：编辑：
      tableHeight: window.innerHeight*.8, //总代理表格动态高度 
      tableEleHeight: window.innerHeight*.8, //下属销售表格动态高度
      curStoreCode:'',//当前总代编号
      curStorename:'',//当前选中的代理名称 
      salesmanOperShow:false,//增改查存储分组弹窗
      districtList:[],//省市的区列表
      // 省市区
      areaAddrList:[],
      salesmanOperForm:{
        openid:'',
        pflowcode:'',
        pflowname:'',
        flowname:'',
        mobile:'',
        idnumber:'',
        pcdinfo:[],
        districtcode:'',
        district:'',
        addrdet:'',
        status:'',
      },//销售员表单
      salesmanRules: {
        flowname: [
          { required: true, message: '请输入销售员姓名'},
          { min: 1, max: 20, message: '长度必须在 1 到 20 之间', trigger: 'blur' }
        ],
        mobile:[ //手机号码 
          { required: true, message: '请输入手机号码'},
          { min: 11, max:11, message: '手机号码应为11位', trigger: 'blur' },
          { 
            validator(rule,value,callback){
              if(that.telCheck(value,1) === 2){
                callback(new Error("请输入合法的手机号码！"));
              }else{
                callback();
              }
            },
            trigger: "blur" 
          },
        ],
        idnumber:[ //支局（单位）名称 
          { required: true, message: '请输入支局（单位）名称'},
          { min: 1, max: 18, message: '长度必须在 1 到 18 之间', trigger: 'blur' },
          // { 
          //   validator(rule,value,callback){
          //     if(that.telCheck(value) === 2){
          //       callback(new Error("请输入合法的支局（单位）名称！"));
          //     }else{
          //       callback();
          //     }
          //   },
          //   trigger: "blur" 
          // },
        ],
        // idnumber: [
        //   { required: true, message: '请输入身份证号', trigger: 'blur' },
        //   { min: 18, max:18, message: '身份证号应为18位', trigger: 'blur' },
        //   { required: true, validator: (rule, value, callback)=>{this.validIDNO(rule, value, callback)}, trigger: ['blur'] }
        // ],
        pcdinfo: [
          { required: true, message: '请选择省市区'}
        ],
        addrdet: [
          { required: true, message: '请输入详细地址'},
          { min: 5, max: 50, message: '长度必须在 5 到 50 之间', trigger: 'blur' }
        ],
        pflowcode:[
          { required: true, message: '请选择所属总代理',trigger: 'blur' },
        ],
      },
      flowList:[],//模糊检索列表
      curFlowCode:'',//当前销售员编号
      applicantInfo:{},//申请人详情
      userInfoMd:{},//门店登录信息
    }
  },
  filters:{
    //审核状态过滤
    examineStatusFilter(val){
      if(val== 0){
        return '待审核'
      }else if(val==1){
        return '审核通过'
      }else if(val==2){
        return '审核不通过'
      }
    },
  },
  components: {
    CompanyTab: resolve => require(["@/components/ManageFolder/CompanyTab.vue"],resolve), //头部tab组件
    Page: resolve => require(["@/components/common/Page.vue"], resolve),
    ProvincesOrCity: resolve =>require(["@/components/common/ProvincesOrCity.vue"], resolve),//省市区选择
  },
  watch: {
  },
  methods: {
    //查询销售方法
    querySalesSearch(){
      this.currentStorePage=1;
      this.getComFlowList();
    },
    //获取销售人员列表
    getComFlowList(){
      var params = {
        isapply:1,
        pflowcode:this.userInfoMd.flowcode,
        flowname:this.salesmanSearchForm.flowname,
        mobile:this.salesmanSearchForm.mobile,
        idnumber:this.salesmanSearchForm.idnumber,
        status:this.salesmanSearchForm.status,
        objtype:'4',  //0:门店；1：发货网点；2：一级分销；4：微门店；5.企业微门店；
        examinestatus:this.salesmanSearchForm.examinestatus, //审核状态 0：待审核；1：通过；3：不通过
        pageparam:{
          pagesize: this.pageSize, //每页条数
          currentpage: this.currentPage, //当前页数
          isnewcomp: 1 //是否需要重新统计页数
        }
      }
      this.isSalesmanLoad = true;
      api.GET_FLOWLIST(params).then((res) =>{
        if(res.data.status == '200'){
          this.isSalesmanLoad = false;
          this.salesManData = res.data.data;
          if(res.data.pagebean){
            this.pagebean = res.data.pagebean
          }
        }else{
          Message({
            message:res.data.message,
            type:'error'
          })
        }
      })
    },
    
    // 接收销售员分页信息
    updatePage(size,num) {
      this.pageSize = size;
      this.currentPage = num;
      this.getComFlowList();
    },
    //启用禁用设置
    handleSwitch(row){  
      if(row.status){
        MessageBox.confirm(`确定禁用该销售人员?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.changeStatus(row.flowcode,0)
        }).catch(() => {

        });
      }else{
        this.changeStatus(row.flowcode,1)
      }
    },
    //改变状态
    changeStatus(flowcode,status){
      let params = {
        ucodes:flowcode,
        status:status
      }
      api.UPDATEFLOWSTATUS(params).then((res) => {
        if(res.data.status == '200'){
            this.$message.success(`${status?'启用':'禁用'}成功`);
            this.getComFlowList();
        }else{
            this.$message.error(res.data.message)
        }
      })
    },
    //获取销售员详情
    getSalesManDetail(flowcode){
      api.GET_FLOWDETAIL({flowcode:flowcode}).then(res => {
        if(res.data.status == "200" &&res.data.data) {
          this.applicantInfo = res.data.data;
          if(this.salesmanOperType==1){
            this.salesmanOperForm = {
              flowname:res.data.data.flowname,
              mobile:res.data.data.mobile,
              idnumber:res.data.data.idnumber,
              pflowcode:res.data.data.pflowcode,
              pflowname:res.data.data.pflowname,
              pcdinfo:[{
                name: res.data.data.province,
                code: res.data.data.provincecode
              },
              {
                name: res.data.data.city,
                code: res.data.data.citycode
              },
              {
                name: res.data.data.district,
                code: res.data.data.districtcode
              }],
              // districtcode:res.data.data.districtcode,
              // district:res.data.data.district,
              addrdet:res.data.data.addrdet,
              status:res.data.data.status?true:false,
            }
            this.getDistrictList();//获取区列表
          }
        }else{
          this.$message.error('获取销售员详情信息失败！')
        }
      })
    },
    //增改查销售员弹窗
    salesmanOperate(val,flowcode){
      this.salesmanOperType = val;
      this.salesmanOperShow = true;
      this.curFlowCode = flowcode;
      this.getSalesManDetail(flowcode);
    },
    //关闭查改弹窗
    saveSalesmanInfo(val){
      if(val==1){
        this.$refs['salesmanOperForm'].validate((valid) => {
          if(valid){
            let params = {
              addtype:0,
              isapply: 1, //0：其他；1:申请修改 不传认为是0
              objtype:4,
              flowcode:this.curFlowCode,
              flowname:this.salesmanOperForm.flowname,
              mobile:this.salesmanOperForm.mobile,
              idnumber:this.salesmanOperForm.idnumber,
              pflowcode:this.salesmanOperForm.pflowcode,
              provincecode:this.salesmanOperForm.pcdinfo[0].code,
              province:this.salesmanOperForm.pcdinfo[0].name,
              citycode:this.salesmanOperForm.pcdinfo[1].code,
              city:this.salesmanOperForm.pcdinfo[1].name,
              districtcode:this.salesmanOperForm.pcdinfo[2].code,
              district:this.salesmanOperForm.pcdinfo[2].name,
              addrdet:this.salesmanOperForm.addrdet,
              status:this.salesmanOperForm.status?1:0,  
            }
            api.SAVEFLOW(params).then(res =>{
              if(res.data.status=='200'){
                this.$message({
                  type: 'success',
                  message: '编辑成功！'
                })
                this.$refs.salesmanOperForm.resetFields();
                this.salesmanOperShow = false;
                this.getComFlowList();// 更新销售员列表
              }else{
                this.$message.error(res.data.message)
              }
            })
          }else{
            return false
          }
        })
      }else{
        if(this.salesmanOperType==1){
          this.$refs.salesmanOperForm.resetFields();
        }
        this.salesmanOperShow = false;
      }
    },
    // // 身份证正则验证
    // validIDNO(rule, value, callback){
    //   var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
    //   if (value && !reg.test(value)) {
    //     callback(new Error("请输入正确的身份证号！"))
    //   } else {
    //     callback();
    //   }
    // },
    //获取省市区的区列表
    getDistrictList(){
      if(this.applicantInfo.citycode){
        api.GET_ADDRESSBYCODE({ code: this.applicantInfo.citycode }).then(res =>{
          if (res.data.status === "200") {
            this.districtList = res.data.data;
          } else {
            Message.error({ message: "获取区列表失败！" });
          }
        })
      }
    },
    //区县改变
    DSChange(val){
      if(this.districtList.length>0){
        this.districtList.map((item,index) =>{
          if(item.Code == val ){
            this.salesmanOperForm.district = item.FullName
            return
          }
        })
      }
    },
    //动态获取表格高度
    getHeight() {
      let tbEleHeight = this.$refs.salesTable.$el.offsetTop; //元素表格顶部检索条件占据的高度
      this.tableEleHeight = window.innerHeight - tbEleHeight - 130; 
    },
  },
  created() {
    //页面浏览器视窗变化绑定resize事件
    window.addEventListener("resize", this.getHeight);
  },
  //   *********************************************************************初始化
  mounted(){
    // 获取企业代码
    let cmpyinfo = localStorage.getItem("cmpyinfo");
    if(cmpyinfo && cmpyinfo != 'null' && cmpyinfo != 'undefined'){
        this.qydm = JSON.parse(cmpyinfo).qydm;
    }

    if(localStorage.getItem('userInfoMd')) {
      this.userInfoMd = JSON.parse(localStorage.getItem('userInfoMd')); 
      if(this.userInfoMd.flowcode) {
        this.getComFlowList();//获取销售员列表
      }
    }

    setTimeout(()=>{
      this.getHeight();
    },200)
  },
  destroyed(){ 
    window.removeEventListener('resize', this.getHeight); //销毁监听浏览器视窗变化
  }
}
</script>

<style scoped>
.mainPart {padding: 20px; height: calc(100% - 50px);}
.pt60 {padding-top:64px;}

.blueColor.on {font-weight: 600;}
.textFl.pdr30 {max-width: calc(100% - 30px);padding-right: 30px;}
.pdr70 {display:block;padding-right:70px;max-width: calc(100% - 70px);}

.wechatAvatar p{ width:50px; height:50px; border: solid 1px #dcdfe6; border-radius: 100%; margin-right: 10px; position:relative; }
.wechatAvatar p img{ border-radius:100%; }
.wechatAvatar span{ display:inline-block; width: calc(100% - 65px); }
.textFl.iconuser {font-size: 14px;}
.linkNum .iconiPhone {padding-right:20px;}
.linkNum dd {white-space: nowrap;}
.linkNum [class^="icon"]:before {padding-right:5px; font-size: 16px;}


/*销售员改查弹窗 start*/
.examineDlg >>> .el-dialog {width: 700px;}
.examineDlg >>> .el-dialog__body {max-height: 580px;}
.examineDlg >>> .el-form-item:not(.allWidth) .el-form-item__content {width:65%; min-width: 200px; max-width: 340px;}
.examineDlg >>> .el-form-item__content .el-input,
.examineDlg >>> .el-form-item__content .el-select,
.examineDlg >>> .el-form-item__content .el-cascader {width:100%;}
.examineDlg >>> .el-form-item.noformitem {margin-bottom:10px;}
.noformitem >>> .el-form-item__label {line-height:20px;padding:5px 12px 5px 0;}
.noformitem >>> .el-form-item__content {line-height:20px;padding:5px 0;}
.noformitem >>> .el-tag{margin-right:5px;}

.wxWrap {align-items: center;}
.wxWrap .wxLogo {position:relative;display:inline-block; width:35px; height:35px;margin-right:10px; border-radius:17.5px; overflow:hidden;border:solid 1px #ebeef5;}
.wxWrap .wxLogo + p {flex:1;max-width: calc(100% - 47px);}
.basicWrap{width:70%;margin:20px auto;}
.basicWrap li{margin:20px 0;display:-webkit-flex;display:flex}
.basicWrap li:first-child{margin-top:10px}
.basicWrap li>em{color:#333;width:140px;display:inline-block;text-align:right;min-width:140px}
.basicWrap li b{flex:1;max-width:calc(100% - 140px);color:#999;}

/* .flexItem >>> .el-form-item__content {display: -webkit-flex;display: flex;align-items: center;}
.flexItem .disabledSpan {padding:0 15px; white-space: nowrap; line-height: 38px;background:#F5F7FA; color:#999; border:1px solid #DCDFE6; border-right:none; border-radius:4px 0 0 4px;}
.threeSel >>> .el-input__inner {border-radius:0 4px 4px 0!important;border-left:none!important;} */
.comForm >>> .el-textarea .el-input__count {line-height: 1!important;}
/*审核销售员改查弹窗弹窗 end*/
</style>



// WEBPACK FOOTER //
// src/views/ManageFolder/PlatformUser/SalesmanManage.vue